export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap font-heading">91黑料吃瓜</span>
            </div>
            <p className="text-xs md:text-sm leading-relaxed text-foreground-400">
              全网领先的91吃瓜在线观看与91吃瓜视频在线观看聚合平台。覆盖最新黑料视频、爆料视频在线播放，满足用户直接看瓜的需求。每日更新，实时追踪，做你身边最靠谱的吃瓜伙伴。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快捷导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '视频专区', href: '#media' },
                { label: '热门话题', href: '#topics' },
                { label: '最新快讯', href: '#updates' },
                { label: '吃瓜榜单', href: '#ranking' },
                { label: '投稿爆料', href: '#contact' },
              ].map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                  className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {['娱乐圈大瓜', '网红翻车实录', '企业内幕曝光', '社会热点追踪', '匿名爆料专区', '91吃瓜在线播放'].map((cat, i) => (
                <a
                  key={i}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector('#index');
                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                  className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2019-2026 91黑料吃瓜 | 本站内容仅供娱乐，如有侵权请联系删除
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-primary-400 transition-colors">投诉指引</span>
          </div>
        </div>
      </div>
    </footer>
  );
}